import { http } from "../api/http";

export const permissionGroupRunbookService = {
  getRunbooksForGroup,
  getGroupsForRunbook,
  assign,
  remove,
};

async function getRunbooksForGroup(groupId) {
  let url = `/permissiongrouprunbook/group/${groupId}`;

  return await http.get(url).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}

async function getGroupsForRunbook(runbookId) {
  let url = `/permissiongrouprunbook/runbook/${runbookId}`;
  return await http.get(url).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}

async function assign(data) {
  let url = "/permissiongrouprunbook";
  return await http.post(url, data).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}

async function remove(groupId, runbookId) {
  let url = `/permissiongrouprunbook?groupId=${groupId}&runbookId=${runbookId}`;
  return await http.delete(url).then((response) => {
    return response;
  }).catch((error) => {
    throw error;
  });
}
